import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { InteractiveCard, designTokens } from '../../design-system';

type HomeServiceCardProps = {
  label: string;
  icon: ReactNode;
  accent: string;
  tint: string;
  onClick: () => void;
};

export function HomeServiceCard({ label, icon, accent, tint, onClick }: HomeServiceCardProps) {
  return <InteractiveCard onClick={onClick} sx={{ minHeight: 132, height: '100%', p: { xs: `${designTokens.layout.surfacePaddingCompact}px`, sm: `${designTokens.layout.surfacePadding}px` }, display: 'flex', alignItems: 'flex-start', flexDirection: 'column', gap: `${designTokens.space.sm}px` }}>
    <Box aria-hidden sx={{ width: 40, height: 40, flexShrink: 0, borderRadius: designTokens.radius.surface, display: 'grid', placeItems: 'center', bgcolor: tint, color: accent, '& svg': { fontSize: 23 } }}>{icon}</Box>
    <Typography sx={{ ...designTokens.typography.componentTitle, color: designTokens.color.primaryText }}>{label}</Typography>
  </InteractiveCard>;
}
